// Image Optimization and Lazy Loading Script
// This script enhances image loading performance for SEO

document.addEventListener('DOMContentLoaded', function() {
  // Convert images to WebP format where supported
  function enhanceImageFormat() {
    // Check WebP support
    const webpSupported = document.createElement('canvas')
      .toDataURL('image/webp').indexOf('data:image/webp') === 0;
    
    if (!webpSupported) return;
    
    // Find all images that aren't already WebP
    const images = document.querySelectorAll('img:not([src$=".webp"])');
    
    images.forEach(img => {
      const src = img.getAttribute('src');
      if (!src || src.includes('data:image')) return;
      
      // For Shopify images, add format=webp parameter
      if (src.includes('.jpg') || src.includes('.png') || src.includes('.jpeg')) {
        if (src.includes('cdn.shopify.com')) {
          // If already has query parameters
          if (src.includes('?')) {
            img.setAttribute('src', src + '&format=webp');
          } else {
            img.setAttribute('src', src + '?format=webp');
          }
        }
      }
    });
  }
  
  // Implement responsive images with srcset
  function implementResponsiveImages() {
    const productImages = document.querySelectorAll('.product-item__image, .product__image');
    
    productImages.forEach(img => {
      const src = img.getAttribute('src');
      if (!src || src.includes('data:image') || img.getAttribute('srcset')) return;
      
      // For Shopify images, create srcset
      if (src.includes('cdn.shopify.com')) {
        // Extract base URL without size parameters
        let baseUrl = src;
        
        // Create srcset with multiple sizes
        const srcset = [
          baseUrl.replace(/(\d+)x(\d+)/g, '400x') + ' 400w',
          baseUrl.replace(/(\d+)x(\d+)/g, '600x') + ' 600w',
          baseUrl.replace(/(\d+)x(\d+)/g, '800x') + ' 800w',
          baseUrl.replace(/(\d+)x(\d+)/g, '1200x') + ' 1200w'
        ].join(', ');
        
        img.setAttribute('srcset', srcset);
        img.setAttribute('sizes', '(max-width: 600px) 400px, (max-width: 1000px) 600px, (max-width: 1400px) 800px, 1200px');
      }
    });
  }
  
  // Enhance image alt text for SEO
  function enhanceImageAltText() {
    const images = document.querySelectorAll('img[alt=""], img:not([alt])');
    
    images.forEach(img => {
      // Try to determine context from parent elements
      let context = '';
      let parent = img.closest('.product-item') || img.closest('.product');
      
      if (parent) {
        const title = parent.querySelector('.product-item__title, .product-meta__title');
        const vendor = parent.querySelector('.product-item__vendor, .product-meta__vendor');
        
        if (title) context += title.textContent.trim();
        if (vendor) context = vendor.textContent.trim() + ' ' + context;
        
        if (context) {
          img.setAttribute('alt', `${context} - Premium designer fashion at LYBSTORE`);
        } else {
          img.setAttribute('alt', 'Luxury fashion item at LYBSTORE');
        }
      } else {
        // Generic alt text for other images
        img.setAttribute('alt', 'LYBSTORE luxury fashion');
      }
    });
  }
  
  // Implement lazy loading for below-the-fold images
  function implementLazyLoading() {
    // Skip if browser supports native lazy loading
    if ('loading' in HTMLImageElement.prototype) {
      document.querySelectorAll('img').forEach(img => {
        if (!img.hasAttribute('loading') && !isInViewport(img)) {
          img.setAttribute('loading', 'lazy');
        }
      });
      return;
    }
    
    // Fallback lazy loading for browsers without native support
    const lazyImages = Array.from(document.querySelectorAll('img:not([loading="eager"])'));
    
    if ('IntersectionObserver' in window) {
      const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            const dataSrc = img.getAttribute('data-src');
            
            if (dataSrc) {
              img.src = dataSrc;
              img.removeAttribute('data-src');
            }
            
            imageObserver.unobserve(img);
          }
        });
      });
      
      lazyImages.forEach(img => {
        if (!isInViewport(img)) {
          const currentSrc = img.src;
          img.setAttribute('data-src', currentSrc);
          img.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1 1"%3E%3C/svg%3E';
          imageObserver.observe(img);
        }
      });
    }
  }
  
  // Helper function to check if element is in viewport
  function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }
  
  // Execute optimizations
  enhanceImageFormat();
  implementResponsiveImages();
  enhanceImageAltText();
  implementLazyLoading();
});
